module.exports = {"please":"Please","logout":"logout","login":"login","clientContent":"<p><a href='/logout'>Log out</a> in order to view events as a Patron or return to the <a href='/events'>Box Office</a></p>","patronContent":"<p><a href='/login'>Log in</a> in order to view this page.</p>"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Forbidden/locales/en.json
// module id = 1755
// module chunks = 0